import React, { useState } from "react";
import styles from "../styles/TownPlanningSidebar.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";

const TownPlanningSidebar = ({ isOpen, onClose }) => {
  const [showImportantLinks, setShowImportantLinks] = useState(false);
  const navigate = useNavigate();

  const toggleImportantLinks = () => setShowImportantLinks(!showImportantLinks);

  return (
    <div className={`${styles["sidebar-container"]} ${isOpen ? styles["sidebar-open"] : ""}`}>
      {/* Header */}
      <div className={styles["sidebar-header"]}>
        <div className={styles["sidebar-logoSection"]}>
          <img src={logo} alt="TP Logo" className={styles["sidebar-logo"]} />
          <div className={styles["sidebar-title"]}>
            <p>Welcome to</p>
            <h3>
              Town <br /> Planning <br /> Helpline
            </h3>
          </div>
        </div>
        <button className={styles["sidebar-closeBtn"]} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>

      {/* Menu List */}
      <ul className={styles["sidebar-menuList"]}>
        <li onClick={() => { navigate("/"); onClose(); }}>Home</li>
        <li>Constitution of India</li>
        <li onClick={() => { navigate("/objectives"); onClose(); }}>Objectives</li>

        <li onClick={toggleImportantLinks} className={styles["sidebar-dropdown"]}>
          <span>Important Links</span>
          <FontAwesomeIcon
            icon={showImportantLinks ? faChevronUp : faChevronDown}
            className={styles["sidebar-arrow"]}
          />
        </li>

        {showImportantLinks && (
          <ul className={styles["sidebar-subMenu"]}>
            <li><a href="https://www.maharashtra.gov.in">Maharashtra Government</a></li>
            <li><a href="https://urban.maharashtra.gov.in">Urban Development Department</a></li>
            <li><a href="https://dtp.maharashtra.gov.in">Town Planning & Valuation Dept</a></li>
            <li><a href="https://mahadma.maharashtra.gov.in">Department of Municipal Admin</a></li>
            <li><a href="https://housing.maharashtra.gov.in">Housing Department</a></li>
            <li><a href="http://igrmaharashtra.gov.in">Inspector General of Registrar</a></li>
            <li><a href="http://mohua.gov.in">Ministry of Housing & Urban Affairs</a></li>
          </ul>
        )}

        <li onClick={() => { navigate("/area-convertor"); onClose(); }}>Calculator</li>
        <li onClick={() => { navigate("/feedback"); onClose(); }}>Feedback</li>
        <li>Share App</li>
        <li onClick={() => { navigate("/disclaimer"); onClose(); }}>Disclaimer</li>
        <li onClick={() => { navigate("/about-us"); onClose(); }}>About Us</li>
      </ul>

      {/* Bottom Floating Buttons */}
      <div className={styles["sidebar-bottomButtons"]}></div>
    </div>
  );
};

export default TownPlanningSidebar;
